import React from 'react'
import UpIcon from '@material-ui/icons/TrendingUp'
import DownIcon from '@material-ui/icons/TrendingDown'
import FlatIcon from '@material-ui/icons/TrendingFlat'

export default function TrendIcon(props) {
    return (
        props.value === 0 ? <FlatIcon style={{color:"#ff9800"}} /> :props.value > 0 ? <UpIcon style={{color:"#4caf50"}} /> : <DownIcon style={{color:"#f44336"}} />
    )
}